import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ContentChild, EventEmitter, forwardRef,
    Input,
    NgModule,
    OnInit, Output,
    Renderer2,
    TemplateRef
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NgZorroAntdModule} from 'ng-zorro-antd';
import {CommonModule} from '@angular/common';
import'rxjs';

import {API} from '../services/api';
import { dropDownAnimation } from '../core/animation/dropdown-animations';
import { tagAnimation } from '../core/animation/tag-animations';
declare let _;
export const /** @type {?} */ EXE_COUNTER_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CitySelectComponent),
    multi: true
};
export class CitySelectComponent implements OnInit, AfterViewInit, ControlValueAccessor {


    result: any[] = [];
    _label: string = '';
    _width = '190px';
/**
 * 控制选择框是否显示
 */
showBox: boolean;
    documentClickListener: any;
    //省市区数据
    provinceData: any[] = [];
    cityData: any[] = [];
    districtData: any[] = [];

    checkedProArr: any[] = [];
    checkedCityArr: any = [];
    checkedDistrictArr: any = [];
    totalTree: any[] = [];
private _value: string;
private onChangeCallback: (_: any) => void = () => {
    };
private onTouchedCallback: () => void = () => {
    };

    
    onChange: EventEmitter<any> = new EventEmitter<any>();

    
    maxNum: number | null = 3;
    
    placeholder: string = '请选择地区';
/**
 * @param {?} v
 * @return {?}
 */
set width(v) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes('%') ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }

     render: TemplateRef<void>;
/**
 * @param {?} api
 * @param {?} rd
 * @param {?} cd
 */
constructor(public api: API,
public rd: Renderer2,
public cd: ChangeDetectorRef) {

    }
/**
 * @return {?}
 */
ngOnInit() {
        this.showBox = false;
        this.getData('provinceData', {'code': '000000000000'});
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
set value(value: string) {
        if (value !== this._value) {
            this._value = value;
            this.onChangeCallback(value);
        }
        ;
    }
/**
 * @return {?}
 */
get value(): string {
        return this._value;
    };
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
/**
 * 隐藏弹窗
 * @return {?}
 */
hide() {
        this.showBox = false;
    }
/**
 * @param {?} pro
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
selectPro(pro, label, $event) {
        $event.stopPropagation();
        if (!pro || !label.checked || $event.target.tagName === 'I') return;
        this.clearClick('provinceData');
        pro.click = true;
        this.districtData = [];
        this.getData('cityData', pro);
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.documentClickListener = this.rd.listen('body', 'click', () => {
            this.hide();
        });
    }
/**
 * 输入框点击事件
 * @param {?} event
 * @return {?}
 */
inputClick(event) {
        this.showBox = true;
        event.stopPropagation();
    }
/**
 * @param {?} pro
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
checkedPro(pro, label, $event) {
        $event.stopPropagation();
        if (label.checked) {
            if (!this.ismaxNum(pro)) {
                $event.preventDefault();
                return;
            }
            this.clearClick('provinceData');
            pro.click = true;
            pro.children.length ? pro.children = [] : null;
            this.checkedProArr.push(pro.code);
            this.totalTree.push(pro);
            this.districtData = [];
            this.getData('cityData', pro);
        } else {
            // 清除 cheked
            this.totalTree.forEach((p) => {
                if (p.code === pro.code) {
                    if (p.children.length) {
                        p.children.forEach((c) => {
                            if (c.children.length) {
                                c.children.forEach((d) => {
                                    if (this.checkedDistrictArr.includes(d.code)) {
                                        this.checkedDistrictArr.splice(this.checkedDistrictArr.indexOf(d.code), 1);
                                    }
                                });
                            }
                            this.checkedCityArr.includes(c.code) ?
                                this.checkedCityArr.splice(this.checkedCityArr.indexOf(c.code), 1) : null;
                        });
                    }
                }
            });
            this.checkedProArr.splice(this.checkedProArr.indexOf(pro.code), 1);
            this.deleteSelect(this.totalTree, pro);
            if (pro.click) {
                this.cityData = [];
                this.districtData = [];
            }
            pro.click = false;
        }
        this.handleResult();
    }
/**
 * @param {?} city
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
selectCity(city, label, $event) {
        $event.stopPropagation();
        //点击文字如果没选中直接return
        if (!city || !label.checked || $event.target.tagName === 'I') return;
        this.clearClick('cityData');
        city.click = true;
        this.getData('districtData', city);
    }
/**
 * @param {?} city
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
checkedCity(city, label, $event) {
        $event.stopPropagation();
        //选中
        if (label.checked) {
            if (!this.ismaxNum(city)) {
                $event.preventDefault();
                return;
            }
            this.clearClick('cityData');
            city.click = true;
            //如果有区 就情空
            city.children.length ? city.children = [] : null;
            this.checkedCityArr.push(city.code);
            //遍历省 添加市
            this.totalTree.forEach((p) => {
                if (p.code === city.parentCode) {
                    p.children.push(city);
                }
            });
            this.getData('districtData', city);
            //取消选中
        } else {

            //清除选择记录
            this.checkedCityArr = this.checkedCityArr.filter(v => v !== city.code);
            //清除市
            this.totalTree.forEach((p, i) => {
                if (p.code === city.parentCode) {
                    if (p.children.length) {
                        p.children.forEach((c, i) => {
                            //遍历删除区checked
                            if (c.code === city.code) {
                                c.children.forEach((d) => {
                                    if (this.checkedDistrictArr.includes(d.code)) {
                                        this.checkedDistrictArr.splice(this.checkedDistrictArr.indexOf(d.code), 1);
                                    }
                                });
                                //删除市数据
                                p.children.splice(i, 1);
                                if (!p.children.length) {
                                    this.cityData = [];
                                }
                            }
                        });
                    }
                }
            });
            if (city.click) {
                this.districtData = [];
            }
            city.click = false;
        }
        this.handleResult();

    }
/**
 * @param {?} district
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
selectDistrict(district, label, $event) {
        $event.stopPropagation();
        //点击文字如果没选中直接return
        if (!district || !label.checked) return;
        this.clearClick('districtData');
        district.click = true;
    }
/**
 * 点击区多选框
 * @param {?} district
 * @param {?} label
 * @param {?} $event
 * @return {?}
 */
checkedDistrict(district, label, $event) {
        $event.stopPropagation();
        //选中
        if (label.checked) {
            if (!this.ismaxNum(district)) {
                $event.preventDefault();
                return;
            }
            this.clearClick('districtData');
            district.click = true;
            this.checkedDistrictArr.push(district.code);
            this.totalTree.forEach((v) => {
                v.children.forEach((v) => {
                    v.code === district.parentCode ? v.children.push(district) : null;
                });
            });
        } else {
            district.click = false;
            this.checkedDistrictArr = this.checkedDistrictArr.filter(v => v !== district.code);
            this.totalTree.forEach((p) => {
                if (p.children.length) {
                    p.children.forEach((c) => {
                        if (c.code === district.parentCode) {
                            c.children = c.children.filter((d) => d.code !== district.code);
                            if (!c.children.length && c.click) {
                                this.districtData = [];
                            }
                        }
                    });
                }
            });
        }
        this.handleResult();
    }
/**
 * @param {?} type
 * @return {?}
 */
clearClick(type) {
        this[type].forEach(v => {
            v.click = false;
        });
    }
/**
 * 获取省市区的数据
 * @param {?} type
 * @param {?} pro
 * @return {?}
 */
getData(type, pro) {
        let /** @type {?} */ cacheArea = this.getCache(pro.code);
        if (cacheArea.length) {
            cacheArea.forEach((v) => {
                v.children = [];
            });
            this.setChecked(type, cacheArea);
            this.setParent(cacheArea, type === 'province' ? {code: -1} : pro);
            this[type] = cacheArea
            return;
        }
        this.api.call('CommonController.findAreasByParent', {code: pro.code}).ok(json => {
            let /** @type {?} */ result = json && json.result || [];
            this.setCache(pro.code, result);
            result.forEach((v) => {
                v.children = [];
            });
            this.setChecked(type, result);
            this.setParent(result, type === 'province' ? {code: -1} : pro);
            this[type] = result
        });
    }
/**
 * @param {?} $event
 * @return {?}
 */
panelClick($event) {
        $event.stopPropagation();
    }
/**
 * @param {?} obj
 * @param {?} $event
 * @return {?}
 */
deleteChoice(obj, $event) {
        $event.stopPropagation();
        this.totalTree.forEach((p, i) => {
            if (( /** @type {?} */((<any>this.checkedProArr))).includes(p.code)) {
                //如果删除省
                if (obj.code === p.code) {
                    p.click = false;
                    //清除省市区checked
                    this.checkedProArr.splice(this.checkedProArr.indexOf(p.code), 1);
                    //清除数据
                    this.totalTree.splice(i, 1);
                    this.result.forEach((v, i) => {
                        if (v.code === obj.code) {
                            this.result.splice(i, 1);
                        }
                    });
                    this.districtData = [];
                    this.cityData = [];
                    return;

                }
                //删除市
                if (p.children.length) {
                    let /** @type {?} */ citys = p.children;
                    citys.forEach((c, i) => {
                        if (this.checkedCityArr.includes(c.code)) {
                            if (obj.code === c.code) {
                                c.click = false;
                                citys.splice(i, 1);
                                //清除省 checked数据
                                if (!citys.length) {
                                    this.cityData = [];
                                }
                                if (citys.click) {
                                    this.districtData = [];
                                }
                                //清除 市checked 数据
                                this.checkedCityArr.splice(this.checkedCityArr.indexOf(c.code), 1);

                                return;
                            }
                            if (c.children.length) {
                                let /** @type {?} */ districts = c.children;
                                districts.forEach((d, i) => {
                                    if (this.checkedDistrictArr.includes(d.code)) {
                                        if (obj.code === d.code) {
                                            d.click = false;
                                            districts.splice(i, 1);
                                            //如果只有一个区 删除上级市
                                            if (!districts.length && c.click) {
                                                this.districtData = [];
                                            }
                                            this.checkedDistrictArr.splice(this.checkedDistrictArr.indexOf(d.code), 1);
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
        this.handleResult();
    }
/**
 * @param {?} type
 * @param {?} data
 * @return {?}
 */
setChecked(type, data) {
        let /** @type {?} */ arr: any[] = [];
        type === 'city' ? arr = this.checkedCityArr : type === 'district' ? arr = this.checkedDistrictArr : this.checkedProArr;
        data.forEach((v) => {
            if (arr.indexOf(v.code) !== -1) {
                v.checked = true;
            }
        });
    }
/**
 * 给省市区数据打上标记
 * @param {?=} data
 * @param {?=} obj
 * @return {?}
 */
setParent(data = [], obj) {
        data.forEach(item => {
            item.parentCode = obj.code;
            item.parentName = obj.name;
        });
    }
/**
 * 删除选中的数据 & 移除子区域
 * @param {?=} data
 * @param {?=} obj 当前选中
 * @return {?}
 */
deleteSelect(data = [], obj) {
        for (let /** @type {?} */ i = 0; i < data.length; i++) {
            if (data[i].code === obj.code) {
                data.splice(i, 1);
            }
        }
    }
/**
 * @return {?}
 */
clear() {
        this._label = '';
        this.totalTree.forEach(p => { p.click = false;});
        this.cityData = [];
        this.districtData = [];
        this.checkedProArr = [];
        this.checkedCityArr = [];
        this.checkedDistrictArr = [];
        this.result = [];
        this.totalTree = [];
        this.handleResult();
    }
/**
 * 处理totaltree
 * @param {?=} type
 * @return {?}
 */
handleResult(type?) {
        this.result = [];
        this._label = '';
        for (let /** @type {?} */ t of this.totalTree) {
            let /** @type {?} */ name = t.name;
            let /** @type {?} */ obj = {
                name: name,
                code: t.code
            };
            let /** @type {?} */ children = t.children;
            if (children.length) {
                for (let /** @type {?} */ c of children) {
                    let /** @type {?} */ children2 = c.children;
                    let /** @type {?} */ cityObj = {
                        name: name + '/' + c.name,
                        code: c.code
                    };
                    // 选中了district
                    if (children2.length) {
                        for (let /** @type {?} */ d of children2) {
                            let /** @type {?} */ districtObj = {
                                name: cityObj['name'] + '/' + d.name,
                                code: d.code
                            };
                            this.result.push(districtObj);
                        }
                    } else {
                        this.result.push(cityObj);
                    }
                }
            } else {
                this.result.push(obj);
            }
        }
        let /** @type {?} */ labels = [], /** @type {?} */ code = [];
        this.result.forEach(v => {
            labels.push(v.name);
            code.push(v.code);
        });
        this._label = labels.join(',');
        this.onChangeCallback(code);
        this.onChange.emit(this.result);
    }
/**
 * input checked
 * @param {?} type
 * @param {?} item
 * @return {?}
 */
itemsIsChecked(type, item) {
        switch (type) {
            case 'province':
                return ( /** @type {?} */((<any>this.checkedProArr))).includes(item.code);
            case 'city':
                return this.checkedCityArr.includes(item.code);
            case 'district':
                return this.checkedDistrictArr.includes(item.code);
        }
    }
/**
 * 限制选择数量
 * @param {?} obj
 * @return {?}
 */
ismaxNum(obj) {
        if (!this.maxNum) {
            return true;
        }
        let /** @type {?} */ values: any = [];
        this.result.forEach(v => {
            values.push(v.code);
        });
        values = values.join(',');
        // let values = _.map(this.result, 'code').join(',');
        let /** @type {?} */ len = this.result.length;
        if (len < this.maxNum) {
            return true;
        } else if (len === this.maxNum && values.includes(obj.parentCode)) {
            return true;
        } else {
            return false;
        }
    }
/**
 * @param {?} code
 * @param {?} data
 * @return {?}
 */
setCache(code: string, data) {
        try {
            let /** @type {?} */ cacheAreaStr = sessionStorage.getItem('cacheAreaData') || '{}';
            let /** @type {?} */ cacheArea = JSON.parse(cacheAreaStr);
            cacheArea[code] = data;
            let /** @type {?} */ newCache = JSON.stringify(cacheArea);
            sessionStorage.setItem('cacheAreaData', newCache);
        } catch ( /** @type {?} */e) {
        }
    }
/**
 * @param {?} code
 * @return {?}
 */
getCache(code: string) {
        try {
            let /** @type {?} */ cacheAreaStr = sessionStorage.getItem('cacheAreaData') || '{}';
            let /** @type {?} */ cacheArea = JSON.parse(cacheAreaStr);
            return cacheArea[code] || [];
        } catch ( /** @type {?} */e) {
            return [];
        }
    }
/**
 * @param {?} i
 * @param {?} v
 * @return {?}
 */
track(i, v) {
        return v.code;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'yzt-area-multiple',
    template: `
      <div class="city-select-container">
          <div class="int-label">
              <input (click)="inputClick($event)" class="select-input" type="text" [(ngModel)]="_label" readonly
                     [ngStyle]="{'width': _width}" [placeholder]="placeholder">
              <span
                      (click)="clear($event)"
                      class="ant-select-selection__clear"
                      style="-webkit-user-select: none;"
                      *ngIf="result.length">
              </span>
          </div>
          <div class="select-content" [class.hide]="showBox != true" cdkConnectedOverlay
               cdkConnectedOverlayHasBackdrop>
              <div class="selected-panel clearfix" (click)="panelClick($event)">
                  <div class="panel-info">已选 {{result.length}} 个 (最多可选 {{maxNum}} 个地区) <span class="clear" (click)="clear()">清空</span>
                  </div>
                  <ul>
                      <li
                              *ngFor="let v of result ;trackBy: track;let i = index"
                              [attr.title]="option?.nzLabel || option?.nzValue"
                              class="ant-select-selection__choice" style="-webkit-user-select: none;">
                          <div class="ant-select-selection__choice__content">{{v.name}}</div><!----><span
                              class="ant-select-selection__choice__remove" (click)="deleteChoice(v, $event)"></span>
                      </li>
                  </ul>
              </div>
              <div class="container clearfix">
                  <ul class="province">
                      <ng-container *ngFor="let province of provinceData;let i = index">
                          <li [class.active]="label._checked"
                              (click)="selectPro(province, label, $event)">
                              <label>
                                  <input #label type="checkbox" (click)="checkedPro(province, label , $event)"
                                         [ngModel]="itemsIsChecked('province',province)">
                                  <i></i>
                              </label>
                              <span [style.color]="province.click? 'red' :''">
                              <ng-container [style.color]="province.click? 'red' :''" *ngIf="!render; else renderContainer">{{ province.name }}</ng-container>
                              <ng-template #renderContainer [ngTemplateOutlet]="render"
                                           [ngTemplateOutletContext]="{ $implicit: province }"></ng-template>
                          </span>
                          </li>
                      </ng-container>
                  </ul>
                  <ul class="city" *ngIf="cityData.length !== 0">
                      <ng-container *ngFor="let city of cityData;let i = index">
                          <li [class.active]="label._checked"
                              (click)="selectCity(city, label ,$event)">
                              <label>
                                  <input #label type="checkbox" (click)="checkedCity(city, label , $event)"
                                         [ngModel]="itemsIsChecked('city',city)">
                                  <i></i>
                              </label>
                              <span [style.color]="city.click? 'red' :''">
                              <ng-container *ngIf="!render; else renderContainer">{{ city.name }}</ng-container>
                              <ng-template #renderContainer [ngTemplateOutlet]="render"
                                           [ngTemplateOutletContext]="{ $implicit: city }"></ng-template>
                          </span>
                          </li>
                      </ng-container>
                  </ul>
                  <ul class="district" *ngIf="districtData.length !== 0">
                      <ng-container *ngFor="let district of districtData;let i = index">
                          <li [class.active]="label._checked"
                              (click)="selectDistrict(district, label ,$event)">
                              <label>
                                  <input #label type="checkbox" (click)="checkedDistrict(district, label , $event)"
                                         [ngModel]="itemsIsChecked('district',district)">
                                  <i></i>
                              </label>
                              <span [style.color]="district.click? 'red' :''">
                              <ng-container *ngIf="!render; else renderContainer">{{ district.name }}</ng-container>
                              <ng-template #renderContainer [ngTemplateOutlet]="render"
                                           [ngTemplateOutletContext]="{ $implicit: district }"></ng-template>
                          </span>
                          </li>
                      </ng-container>
                  </ul>
              </div>
          </div>
      </div>
    `,
    animations: [
        dropDownAnimation,
        tagAnimation
    ],
    styles: [`
      .city-select-container {
        position: relative;
        display: inline-block;
      }
      .city-select-container .selected-panel {
        width: 200px;
        position: relative;
        border: 1px solid #d9d9d9;
        min-height: 38px;
        line-height: 30px;
        margin-bottom: 5px;
        margin-left: -1px;
        border-radius: 4px;
        width: 599px;
        padding: 0px 3px 3px 3px;
      }
      .city-select-container .selected-panel ul {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
      }
      .city-select-container .container {
        background: #fff;
        height: 200px;
      }
      .city-select-container .container ul {
        border: 1px solid #d9d9d9;
        background: #fff;
        border-radius: 4px;
        margin-left: -1px;
        width: 200px;
        height: 100%;
        float: left;
        overflow: auto;
      }
      .city-select-container .container ul li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 7px 15px;
        min-height: 32px;
        -webkit-transition: all .3s;
        transition: all .3s;
      }
      .city-select-container .container ul li:hover {
        cursor: pointer;
        background-color: #ecf6fd;
      }
      .city-select-container .container ul li.active {
        background-color: #ecf6fd;
      }
      .ant-select-selection__choice {
        color: rgba(0, 0, 0, 0.65);
        background-color: #f3f3f3;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 4px;
        max-width: 99%;
        position: relative;
        overflow: hidden;
        -webkit-transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        padding: 0 20px 0 10px;
        margin-top: 3px;
        width: 49%;
        text-align: center;
      }
      .ant-select-selection__choice__remove {
        font-style: normal;
        vertical-align: baseline;
        text-align: center;
        text-transform: none;
        line-height: 1;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: rgba(0, 0, 0, 0.43);
        line-height: inherit;
        cursor: pointer;
        font-weight: bold;
        -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        display: inline-block;
        font-size: 12px;
        font-size: 8px \\9;
        -webkit-transform: scale(0.66666667) rotate(0deg);
        transform: scale(0.66666667) rotate(0deg);
        -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
        zoom: 1;
        position: absolute;
        right: 4px;
        padding: 0 0 0 8px;
        top: 1px;
        font-size: 18px;
      }
      .ant-select-selection__choice__remove::before {
        content: "\\E633";
        display: block;
        font-family: "anticon" !important;
      }
      input[type=checkbox] {
        display: none;
      }
      input[type=checkbox]:checked + i {
        background: #108ee9;
        border-color: #108ee9;
      }
      input[type=checkbox]:checked + i:after {
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
        position: absolute;
        display: table;
        border: 2px solid #fff;
        border-top: 0;
        border-left: 0;
        content: ' ';
      }
      label {
        margin-right: 5px;
      }
      label i {
        content: '';
        cursor: pointer;
        font-size: 12px;
        font-style: normal;
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 1px solid #d9d9d9;
        text-align: center;
        line-height: 12px;
        color: #fff;
        vertical-align: middle;
        margin: -2px 2px 1px 0px;
        border-radius: 2px;
        background-color: #fff;
        -webkit-transition: all .3s;
        transition: all .3s;
        position: relative;
      }
      label i::after {
        -webkit-transform: rotate(45deg) scale(0);
        transform: rotate(45deg) scale(0);
        position: absolute;
        left: 4px;
        top: 1px;
        display: table;
        width: 5px;
        height: 8px;
        border: 2px solid #fff;
        border-top: 0;
        border-left: 0;
        content: ' ';
        -webkit-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
        transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
      }
      label i:hover {
        border-color: #0E85E3;
      }
      .hide {
        display: none !important;
      }
      .clear {
        cursor: pointer;
        margin-left: 10px;
      }
      .panel-info {
        padding-left: 10px;
      }
      .select-content {
        background: #fff;
        position: absolute;
        top: 33px;
        left: 0;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        z-index: 9;
      }
      .select-input {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        background-color: #fff;
        cursor: pointer;
        border-radius: 4px;
        padding-left: 7px;
        padding-right: 7px;
        border: 1px solid #d9d9d9;
        height: 28px;
        margin-bottom: 5px;
      }
      .select-input:hover {
        border-color: #49a9ee;
      }
      .select-input:hover + .ant-select-selection__clear {
        opacity: 1;
      }
      .ant-select-selection__clear {
        display: inline-block;
        font-style: normal;
        vertical-align: baseline;
        text-align: center;
        text-transform: none;
        text-rendering: auto;
        opacity: 0;
        position: absolute;
        right: 8px;
        z-index: 1;
        background: #fff;
        top: 48%;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.25);
        width: 12px;
        height: 12px;
        margin-top: -6px;
        line-height: 12px;
        cursor: pointer;
        -webkit-transition: color 0.3s ease, opacity 0.15s ease;
        -webkit-transition: all 0.3s ease, opacity 0.15s ease;
        transition: all 0.3s ease, opacity 0.15s ease;
      }
      .ant-select-selection__clear:hover {
        opacity: 1;
        color: rgba(0, 0, 0, 0.43);
      }
      .ant-select-selection__clear::before {
        display: block;
        font-family: 'anticon';
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: "\\E62E";
      }
    `],
    providers: [EXE_COUNTER_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: API, },
{type: Renderer2, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onChange': [{ type: Output },],
'maxNum': [{ type: Input },],
'placeholder': [{ type: Input },],
'width': [{ type: Input },],
'render': [{ type: ContentChild, args: ['render', ] },],
};
}

function CitySelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
CitySelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CitySelectComponent.ctorParameters;
/** @type {?} */
CitySelectComponent.propDecorators;
/** @type {?} */
CitySelectComponent.prototype.result;
/** @type {?} */
CitySelectComponent.prototype._label;
/** @type {?} */
CitySelectComponent.prototype._width;
/**
 * 控制选择框是否显示
 * @type {?}
 */
CitySelectComponent.prototype.showBox;
/** @type {?} */
CitySelectComponent.prototype.documentClickListener;
/** @type {?} */
CitySelectComponent.prototype.provinceData;
/** @type {?} */
CitySelectComponent.prototype.cityData;
/** @type {?} */
CitySelectComponent.prototype.districtData;
/** @type {?} */
CitySelectComponent.prototype.checkedProArr;
/** @type {?} */
CitySelectComponent.prototype.checkedCityArr;
/** @type {?} */
CitySelectComponent.prototype.checkedDistrictArr;
/** @type {?} */
CitySelectComponent.prototype.totalTree;
/** @type {?} */
CitySelectComponent.prototype._value;
/** @type {?} */
CitySelectComponent.prototype.onChangeCallback;
/** @type {?} */
CitySelectComponent.prototype.onTouchedCallback;
/** @type {?} */
CitySelectComponent.prototype.onChange;
/** @type {?} */
CitySelectComponent.prototype.maxNum;
/** @type {?} */
CitySelectComponent.prototype.placeholder;
/** @type {?} */
CitySelectComponent.prototype.render;
/** @type {?} */
CitySelectComponent.prototype.api;
/** @type {?} */
CitySelectComponent.prototype.rd;
/** @type {?} */
CitySelectComponent.prototype.cd;
}

export class CitySelectModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule
    ],
    declarations: [
        CitySelectComponent
    ],
    exports: [CitySelectComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CitySelectModule_tsickle_Closure_declarations() {
/** @type {?} */
CitySelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CitySelectModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
